module.exports = __webpack_public_path__ + "static/share-f69c78f68b72fbf5bf30f68e2a727c08.png";